'use strict';
var util = require('../../../../app_fbb_core/cartridge/js/util');

/**
 * @function
 * @description calls the service to mute verint recording
 * @param {String} extension the phone extension to mute
 */
function muteVerint(extension) {
	window.verintMuted = true;
    var url = util.appendParamToURL(Urls.verintMuteRecording, 'extension', extension);
	$.ajax({ 
			url: url,
			method: 'POST', 
			success: function(data) {
				console.log(data);
			}
			
	});
}
/**
 * @function
 * @description calls the service to unmute verint recording
 * @param {String} extension the phone extension to mute
 */
function unmuteVerint(extension) {
	window.verintMuted = false;
    var url = util.appendParamToURL(Urls.verintUnmuteRecording, 'extension', extension);
	$.ajax({ 
			url: url,
			method: 'POST', 
			success: function(data) {
				console.log(data);
			}
			
	});
}
exports.init = function (extension) {

	$( window ).unload(function() {
		if(window.verintMuted){
			//call verint to unute
			unmuteVerint(extension);		
		}
	});
	if(window.pageContext && window.pageContext.ns == 'checkout') {
	 	if($('.billing-cards-section').is(":visible") )  {
	 		if(!window.verintMuted) {
    			muteVerint(extension);    		
	 		}
		}	
 		$( document).ajaxSuccess(function( event, xhr, settings ) {
 			if ( settings.url.indexOf(Urls.verintUnmuteRecording) == -1 && settings.url.indexOf(Urls.summaryRefreshURL) == -1  ){
	 			if($('.billing-cards-section').length > 0 )  {
	 				if(!window.verintMuted) {
    					muteVerint(extension);    		
	 				}
				}
 			}
		});
	 	$(document).on('click','.billing-cards-section', function(e) {
	 		if(!window.verintMuted) {
    			//call verint mute
    			muteVerint(extension);    		
	 		}
		});	
	
		$(document).on("mousedown touchstart",function(e){
  			var $info = $('.billing-cards-section');
  			if (!$info.is(e.target) && $info.has(e.target).length === 0) {
	 			if(window.verintMuted) {
					unmuteVerint(extension);
	 			}    
  			}
		});
	}
	if(window.pageContext && window.pageContext.ns =='account') {
	 	if($('.left-cont.payment-fields').is(":visible") )  {
	 		if(!window.verintMuted) {
    			muteVerint(extension);    		
	 		}
		}		
		$(document).on('click','.add-card', function(e) {
	 		if(!window.verintMuted) {
    			muteVerint(extension);    		
	 		}
		});
	 	$(document).on('click','.left-cont.payment-fields', function(e) {
	 		if(!window.verintMuted) {
    			muteVerint(extension);    		
	 		}
		});		
		$(document).on('click','#applyBtn, .cancel-button',function(e){
	 		if(window.verintMuted) {
				unmuteVerint(extension);
	 		}    
		});	
	}		
}